import {
  CREATE_INFLUENCER,
  UPDATE_INFLUENCER,
  UNLOAD_INFLUENCER,
  RESET_INFLUENCER,
  INFLUENCER_TOGGLE_SUCCESS,
  INFLUENCER_FETCHED_SUCCESS,
} from '../constants/actionTypes';

const initialState = {
  influencer: [],
  errors: {},
  message: '',
  pager: {
    current: 1,
    pageSize: 15,
    total: 0,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CREATE_INFLUENCER:
      return {
        ...state,
      };
    case UPDATE_INFLUENCER:
      return {
        ...state,
        errors: action.payload.errors,
        message: action.payload.msg,
      };

    case UNLOAD_INFLUENCER:
      return initialState;

    case INFLUENCER_FETCHED_SUCCESS:
      return {
        ...state,
        influencer: action.payload.influencer.map((item) => {
          const newItem = { ...item, id: item.id };
          return newItem;
        }),
        pager: action.payload.pager,
      };

    case RESET_INFLUENCER:
      return {
        ...state,
        message: '',
      };

    case INFLUENCER_TOGGLE_SUCCESS:
      return {
        ...state,
        influencer: state.influencer.map((item) => {
          if (item.id !== action.payload.id) return item;
          const newItem = { ...item };
          newItem.is_active = action.payload.active;
          return newItem;
        }),
      };

    default:
      return state;
  }
};
